<template>
    <div>
        <compWrapper v-show="showbox1" :title="$t('fbb.headlogistics.add_logistics_order', { defaultValue: '添加头程物流单' })" theme="primary">
            <compFormEdit
                class="margin-15"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
            <div class="text-right margin-right-10">
                <vButton theme="primary" @click="nextBox">{{$t('fbb.headlogistics.next_step', { defaultValue: '下一步' })}}</vButton>
                <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
            </div>
        </compWrapper>
        <compWrapper v-show="showbox2" :title="$t('fbb.headlogistics.connection_type', { defaultValue: '联系方式' })" theme="info">
            <div v-for="(item,index) in factorylist" :key="index" class="clearfix" style="border-bottom:1px solid #bbb">
                <div class="margin-left-15 margin-top-15">{{$t('fbb.headlogistics.factory_connection', { defaultValue: '工厂联系方式' })}}</div>
                <compFormEdit class="margin-15" ref="editfactory" v-model="factorylist[index]" :formdata="getFactory" :labelWidth="120"></compFormEdit>
                <div class="margin-left-15 margin-top-15">{{$t('fbb.headlogistics.deliver_connection', { defaultValue: '发货方联系方式' })}}</div>
                <compFormEdit class="margin-15" ref="editcontent" v-model="factorylist[index]" :formdata="getContent" :labelWidth="120"></compFormEdit>
            </div>
            <div class="text-right margin-top-15">
                <vButton theme="primary" @click="addnext">{{$t('fbb.headlogistics.continue_add', { defaultValue: '继续添加' })}}</vButton>
                <vButton class="margin-left-10" @click="nextpage">{{$t('fbb.headlogistics.next_step', { defaultValue: '下一步' })}}</vButton>
                <vButton class="margin-left-10 margin-right-15" @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
            </div>
        </compWrapper>
    <vLoading v-if="loading" size="large" transfer loading />

    </div>
</template>

<script>
import { HttpSaveLogisticsOne,HttpInboundOrderList,HttpGetLineName,HttpSeeLogisticsHeadFactory } from "@/service/headlogistics";

import { mapState, mapGetters, mapMutations } from 'vuex';
export default {
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compModal: () => import("@components/templates/modal"),
    },
    data(){
        return {
            formData:{
                // logisticsType:'through',
                currency: 'USD'
            },
            jumprouter: this.$route.params.jump,
            showbox1:true,
            showbox2:false,
            factorylist:[
                {
                    factoryName:'',
                    factoryAddress:'',
                    factoryContact:'',
                    factoryPhone:'',
                    senderName:'',
                    senderAddress:'',
                    senderContact:'',
                    senderPhone:''
                }
            ],
            inboundOrderList:[],
            loading:false,
        }
    },
    created(){
        this.getInboundOrderList()
    },
    computed:{
        ...mapGetters('dictionary', ['getProductList', 'getAccountList', 'getWarehouseList', 'getOrgList']),
        ...mapGetters('common', ['getCurrencyList']),
        getBase(){
            return [
                // {
                //     label: '发运类型',
                //     key: 'logisticsType',
                //     tag: 'vRadio',
                //     props: {
                //         strict: false,
                //     },
                //     options: [{
                //         trueValue: 'through',
                //         label: '直达'
                //     }, {
                //         trueValue: 'transfer',
                //         label: '转运'
                //     }]
                // },
                {
                    label: this.$t('fbb.inbound.storage_number', { defaultValue: '入库计划单号' }),
                    key: "inboundPLanOrderNos",
                    tag: "vSelect",
                    options:this.inboundOrderList.map(item=>{
                        // console.log(item)
                        return {
                            value:item.inboundPlanOrderNo,
                            label:item.inboundPlanOrderNo+" ( "+item.lineName+" )"+" [ "+item.orgWarehouseCode+" ]"
                        }
                    }),
                    on:{
                        'on-change':(value)=>{
                            this.getLineName(value)
                        }
                    },
                    props: {
                        filterable: true,
                        multiple:true,
                    },
                },
                {
                    label: this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' }),
                    key: "associatedNo",
                    required:false,
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    tag: "vInput",
                    key: "lineName",
                    query:true,
                },
                {
                    label: this.$t('fbb.headlogistics.forwarder_type', { defaultValue: '贷代类型' }),
                    key: "carrierType",
                    tag: "vSelect",
                    options: [
                        {value:0,label: this.$t('fbb.headlogistics.carrier_type_standard', { defaultValue: '标准' })},
                        {value:1,label: this.$t('fbb.headlogistics.carrier_type_other', { defaultValue: '其他' })},
                    ],
                },
                {
                    label: this.$t('fbb.headlogistics.expect_stuffing_date', { defaultValue: '预计交货日期' }),
                    tag: "vDatepicker",
                    key: "expectStuffingDate",
                    props: {
                        format: 'yy-mm-dd',
                    },
                    required:true,
                },
                {
                    label: this.$t('fbb.headlogistics.factory_batch_number', { defaultValue: '工厂批次号' }),
                    key: "factoryBatchNo",
                    required:false,
                },
                // {
                //     label: '预计开船日期',
                //     tag: "vDatepicker",
                //     key: "estimateSailAt",
                //     props: {
                //         format: 'yy-mm-dd',
                //     },
                //     required:true,
                // },
                {
                    label: this.$t('global.common.currency', { defaultValue: '币种' }),
                    key: "currency",
                    tag: "vSelect",
                    options:this.getCurrencyList.map(item=>{
                        return {
                            value:item,
                            label:item,
                        }
                    })
                },
                {
                    label: this.$t('global.common.notes', { defaultValue: '备注' }),
                    key:'remark',
                    tag: "vTextarea",
                    required:false,
                },
            ]
        },
        getFactory(){
            return [
                {
                    label: this.$t('fbb.headlogistics.factory_name', { defaultValue: '工厂名称' }),
                    key: "factoryName",
                },
                {
                    label: this.$t('fbb.headlogistics.factory_address', { defaultValue: '工厂地址' }),
                    key: "factoryAddress",
                },
                {
                    label: this.$t('fbb.headlogistics.factory_contact', { defaultValue: '联系人' }),
                    key: "factoryContact",
                },
                {
                    label: this.$t('fbb.inbound.contact_phone', { defaultValue: '联系电话' }),
                    key: "factoryPhone",
                },
            ]
        },
        getContent(){
            return [
                {
                    label: this.$t('fbb.inbound.shipper_name', { defaultValue: '发货方名称' }),
                    key: "senderName",
                },
                {
                    label: this.$t('fbb.inbound.shipper_address', { defaultValue: '发货方地址' }),
                    key: "senderAddress",
                },
                {
                    label: this.$t('fbb.headlogistics.factory_contact', { defaultValue: '联系人' }),
                    key: "senderContact",
                },
                {
                    label: this.$t('fbb.inbound.contact_phone', { defaultValue: '联系电话' }),
                    key: "senderPhone",
                },
            ]
        },
    },
    methods:{
        getLineName(arrvalue){
            let arrstring = arrvalue.join(",")
            HttpGetLineName({
                inboundPlanOrderNos:arrstring
            }).then(res=>{
                console.log(this.formData.lineName);
                if (this.formData.lineName) {
                    this.$set(this.formData, 'lineName', this.formData.lineName + ', ' + res.data.name);
                }
                else {
                    this.$set(this.formData,'lineName',res.data.name)
                }
                // this.formData.lineName = res.data.name
            },err=>{
                this.$VMessage.error(err.message)
            })
            let arrNo = []
            let arrbatch = [],arrdata=[];
            this.inboundOrderList.map(item=>{
                arrvalue.map(json=>{
                    if(json == item.inboundPlanOrderNo){
                        if (item.sourceNo) {
                            arrNo.push(item.sourceNo)
                        }
                        arrbatch.push(item.batchNumber)
                    }
                })
            })
            this.formData.associatedNo = arrNo.join(',')
            arrbatch.map(data=>{
                if(data!=''){
                    arrdata.push(data)
                }
            })
            this.$set(this.formData,'factoryBatchNo',arrdata.join(","))
        },
        getInboundOrderList(){
            HttpInboundOrderList({
                'search[IN_inboundPlanOrderStatus]':[8,10]
            }).then(res=>{
                this.inboundOrderList = res.data
            },err=>{
                this.$VMessage.error(err.message)
            })
        },
        async nextBox(){
            // formbase
            const valid = await this.$refs.editform.validate()
            if (!valid) return;

            // 去掉发运类型
            // // 如果为直达，判断入库计划单号是不是同一个仓库
            // if(this.formData.logisticsType == 'through'){
            //     let arr = [];
            //     let flag = false;
            //     this.inboundOrderList.map(item=>{
            //         this.formData.inboundPLanOrderNos.map(json=>{
            //             if(item.inboundPlanOrderNo == json){
            //                 arr.push(item)
            //             }
            //         })
            //     })
            //     arr.map((datajson,index)=>{
            //         if(arr[0].orgWarehouseCode !== arr[index].orgWarehouseCode){
            //             flag = true
            //         }
            //     })
            //     if(flag){
            //         this.$VMessage.error('所选的入库单号仓库不统一，请重新选择');
            //         return
            //     }
            // }

            HttpSeeLogisticsHeadFactory({
                orgId:global.SYSID,
                inboundPLanOrderNos:this.formData.inboundPLanOrderNos
            }).then(res=>{
                // console.log(res)
                if(res.data.length>0){
                    this.factorylist = res.data
                }
            })
            this.showbox1 = false;
            this.showbox2 = true;
        },
        addnext(){
            // console.log(4544545)
            let data = {
                factoryName:'',
                factoryAddress:'',
                factoryContact:'',
                factoryPhone:'',
                senderName:'',
                senderAddress:'',
                senderContact:'',
                senderPhone:''
            }
            // console.log(this.factorylist)
            this.factorylist.push(data)
        },
        async nextpage(){
            // console.log(this.factorylist)
            let dataflag;
            // 验证必填
            this.factorylist.map(item=>{
                if(item.factoryName==''||item.factoryAddress==''||item.factoryContact==''||item.factoryPhone==''||item.senderName==''||item.senderAddress==''||item.senderContact==''||item.senderPhone==''){
                    dataflag = true
                }
            })
            if(dataflag){
                this.$VMessage.error(this.$t('fbb.headlogistics.info_empty', { defaultValue: '必填项不能为空' }));
                return;
            }
            this.formData.inboundPLanOrderNos = (this.formData.inboundPLanOrderNos || []).join(',')
            console.log(this.formData.inboundPLanOrderNos)
            // 提交当前页面的内容
            this.loading = true;
            HttpSaveLogisticsOne({
                orgId:global.SYSID,
                ...this.formData,
                logisticsContactRequests:this.factorylist
            }).then(res=>{
                this.loading = false;
                this.$VMessage.success(res.message)
                // 跳转到相对应页面
                this.$router.push({
                    name: 'headlogiticsUpdate',
                    params: { type: "edit" },
                    query: { id: res.data.id },
                });
            },err=>{
                this.loading = false;
                this.$VMessage.error(err.message)
            })

        },
        cancel(){
            if(this.jumprouter == 'inbound'){
                this.$router.push({
                    name: 'inboundBillclient'
                })
            }else{
                this.$router.push({
                    name: 'headlogiticsList'
                })
            }
        },
    },
}
</script>
